define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var mediaQueryStringForDesktop = "(min-width: 1200px)";
    var mediaQueryStringForSmallDesktop = "(min-width: 992px) and (max-width: 1199px)";
    var mediaQueryStringForDesktopOrLarger = "(min-width: 992px)";
    var mediaQueryStringForTablet = "(min-width: 768px) and (max-width: 991px)";
    var mediaQueryStringForTabletOrSmaller = "(max-width: 991px)";
    var mediaQueryStringForMobile = "(max-width: 767px)";
    var $mobileDetectionElement = $("<div />");
    var $body = $("body");
    var registeredMediaListeners = {};
    var mobileDetectionClass = "mobileDetection";
    var mobileClass = "mobileDetection_mobile";
    var tabletClass = "mobileDetection_tablet";
    var smallDesktopClass = "mobileDetection_smallDesktop";
    var desktopClass = "mobileDetection_desktop";
    function addMediaQueryRuleForClass(mediaQuery, cssClass) {
        var mediaQueryRule = "@media all and " + mediaQuery + "{";
        mediaQueryRule += "." + cssClass + "{visibility:visible}";
        mediaQueryRule += "}";
        return mediaQueryRule;
    }
    function createMobileDetectionStyleTag() {
        var styleTagContent = "." + mobileDetectionClass + "{visibility:hidden;}";
        styleTagContent += addMediaQueryRuleForClass(mediaQueryStringForMobile, mobileClass);
        styleTagContent += addMediaQueryRuleForClass(mediaQueryStringForTablet, tabletClass);
        styleTagContent += addMediaQueryRuleForClass(mediaQueryStringForSmallDesktop, smallDesktopClass);
        styleTagContent += addMediaQueryRuleForClass(mediaQueryStringForDesktop, desktopClass);
        return $("<style type='text/css'>").text(styleTagContent);
    }
    var $mobileDetectionStyleTag = createMobileDetectionStyleTag();
    $body.append($mobileDetectionStyleTag);
    $mobileDetectionElement.addClass(mobileDetectionClass);
    $mobileDetectionElement.append($("<span />").addClass(mobileClass));
    $mobileDetectionElement.append($("<span />").addClass(tabletClass));
    $mobileDetectionElement.append($("<span />").addClass(smallDesktopClass));
    $mobileDetectionElement.append($("<span />").addClass(desktopClass));
    $body.append($mobileDetectionElement);
    function getDevice() {
        if (isMobile()) {
            return "mobile";
        }
        if (isTablet()) {
            return "tablet";
        }
        if (isDesktop()) {
            return "desktop";
        }
        return "fatal error in mobile detection";
    }
    exports.getDevice = getDevice;
    function isMobile() {
        return $(".mobileDetection_mobile").css("visibility") === "visible";
    }
    exports.isMobile = isMobile;
    function isTablet() {
        return $(".mobileDetection_tablet").css("visibility") === "visible";
    }
    exports.isTablet = isTablet;
    function isDesktop() {
        return $(".mobileDetection_smallDesktop").css("visibility") === "visible" || $(".mobileDetection_desktop").css("visibility") === "visible";
    }
    exports.isDesktop = isDesktop;
    function matchMediaDesktop(matchMediaListener) {
        var mediaQueryDesktop = makeMediaQuery(mediaQueryStringForDesktopOrLarger);
        applyMediaQuery(mediaQueryDesktop, matchMediaListener, isDesktop);
    }
    exports.matchMediaDesktop = matchMediaDesktop;
    function matchMediaTablet(matchMediaListener) {
        var mediaQueryTablet = makeMediaQuery(mediaQueryStringForTablet);
        applyMediaQuery(mediaQueryTablet, matchMediaListener, isTablet);
    }
    exports.matchMediaTablet = matchMediaTablet;
    function matchMediaMobile(matchMediaListener) {
        var mediaQueryMobile = makeMediaQuery(mediaQueryStringForMobile);
        applyMediaQuery(mediaQueryMobile, matchMediaListener, isMobile);
    }
    exports.matchMediaMobile = matchMediaMobile;
    function matchMediaTabletOrSmaller(matchMediaListener) {
        var mediaQueryTabletOrSmaller = makeMediaQuery(mediaQueryStringForTabletOrSmaller);
        applyMediaQuery(mediaQueryTabletOrSmaller, matchMediaListener, function () {
            return isMobile() || isTablet();
        });
    }
    exports.matchMediaTabletOrSmaller = matchMediaTabletOrSmaller;
    function applyMediaQuery(mediaQuery, listener, fallbackMobileDetection) {
        if (window.matchMedia) {
            var key = mediaQuery.media + listener.toString();
            mediaQuery = window.matchMedia(mediaQuery.media);
            if (!registeredMediaListeners[key]) {
                registeredMediaListeners[key] = true;
                mediaQuery.addListener(listener);
            }
        }
        else {
            mediaQuery.matches = fallbackMobileDetection();
        }
        listener(mediaQuery);
    }
    function makeMediaQuery(mediaQueryString) {
        return {
            matches: false,
            media: mediaQueryString
        };
    }
});
